import axios from 'axios';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

const state = {
  authenticated: false,
  profile: {
    permissions: [],
    user: {}
  }
};

const getters = {
  isAuthenticated: state => state.authenticated,
  getUserPermissions: state => state.profile.permissions,
  getUserProfile: state => state.profile,
  getName: state => state.profile.name,
  getOrg: state => state.profile.org
};

const actions = {
  login({ commit }, { username, password }) {
    return new Promise((resolve, reject) => {
      axios({ url: 'login', data: { username, password }, method: 'POST' })
        .then(resp => {
          commit("authSuccess", resp.data)
          resolve(resp)
        })
        .catch(err => {
          commit("authFailure")
          reject(err)
        })
    })
  },
  logoutRequest(context) {
    return new Promise((resolve) => {
      axios({ url: 'logout', method: 'POST' })
        .then(() => {
          context.commit("logout")
          resolve(true)
        })
        .catch(() => {
          context.commit("logout")
          resolve(true)
        })
    })
  },
  async changePassword({ commit }, password) {
    const response = await axios.put('/api/user/profile/password', password, {
      headers: {
        'Content-Type': 'text/plain',
      }
    })
    const profile = response.data
    commit('setPasswordData', profile)
  }
};

const mutations = {
  authSuccess(state, response) {
    state.authenticated = true
    state.profile = response.profile
  },
  authFailure(state) {
    state.authenticated = false
    state.profile = {}
  },
  logout(state) {
    state.authenticated = false
    state.profile = {}
  },
  setPasswordData: (state, profile) => {
    state.profile.lastPwChange = profile.lastPwChange
  }

}

export default {
  state,
  actions,
  mutations,
  getters
};